var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "pretty p-switch p-fill" }, [
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.typeCheckJSON,
          expression: "typeCheckJSON"
        }
      ],
      attrs: { type: "checkbox" },
      domProps: {
        checked: Array.isArray(_vm.typeCheckJSON)
          ? _vm._i(_vm.typeCheckJSON, null) > -1
          : _vm.typeCheckJSON
      },
      on: {
        change: function($event) {
          var $$a = _vm.typeCheckJSON,
            $$el = $event.target,
            $$c = $$el.checked ? true : false
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v)
            if ($$el.checked) {
              $$i < 0 && (_vm.typeCheckJSON = $$a.concat([$$v]))
            } else {
              $$i > -1 &&
                (_vm.typeCheckJSON = $$a
                  .slice(0, $$i)
                  .concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.typeCheckJSON = $$c
          }
        }
      }
    }),
    _vm._v(" "),
    _vm._m(0)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "state p-info" }, [
      _c("label", [_vm._v("Type Check")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }